import { twMerge } from 'tailwind-merge'

type DividerProps = {
  label?: string
} & React.ComponentPropsWithoutRef<'div'>

export default function Divider({ className, label }: DividerProps) {
  className = twMerge('relative py-3', className)

  return (
    <div className={className}>
      <div aria-hidden='true' className='absolute inset-0 flex items-center'>
        <div className='w-full border-t' />
      </div>
      {label && (
        <div className='relative flex justify-center'>
          <span className='bg-white px-2 text-sm text-zinc-500'>{label}</span>
        </div>
      )}
    </div>
  )
}
